// ─────────────────────────────────────────────
//  AssignSeatSection — filling an EMPTY seat (no CRNA, or no supervising
//  doctor) from the room modal.
//
//  ⚠️ DELIBERATELY NOT THE RELIEVE PATH. Nothing is being vacated, so there is
//  no disposition (home / unassigned / travel) to pick, and offering one would
//  ask where to send a person who was never here.
//
//  Both seats used to render a control ONLY when somebody was already in them,
//  so an uncovered room offered no way to cover it: you could relieve a person,
//  never assign one. That is the dead end behind "3 rooms have no supervising
//  MD" and "1 room uncovered" on the board — the warning named the problem and
//  the fix was nowhere.
// ─────────────────────────────────────────────
import React from "react";
import Button from "../Button";
import st from "./caseModalStyles";

export default function AssignSeatSection({
  title,
  emptyLabel,
  pickerLabel,
  placeholder,
  pool = [],
  value,
  onChange,
  onAssign,
  action,
  busy = false,
}) {
  return (
    <div style={st.section}>
      <div style={st.sectionTitle}>{title}</div>
      <div style={st.timesRow}>
        <label style={st.field}>
          {emptyLabel}
          <select
            style={st.select}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            aria-label={pickerLabel}
          >
            <option value="">{placeholder}</option>
            {pool.map((p) => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>
        </label>
        <Button onClick={onAssign} disabled={busy || !value}>{action}</Button>
      </div>
    </div>
  );
}
